import React from 'react';
import OkNgoBoxFooter from 'components/okNgoBoxFooter/okNgoBoxFooter';

const {
    DEV_HOST,
    QA_HOST,
    OCULTO_HOST,
    PROD_HOST,
    STAGING_ASSETS_URL,
    QA_ASSETS_URL,
    OCULTO_ASSETS_URL,
    DEV_ASSETS_URL,
    PROD_ASSETS_URL
} = require('constants/index');

const getUrlImages = (url, environmentConfig) => {
    switch (environmentConfig) {
        case DEV_HOST:
            return `${DEV_ASSETS_URL}${url}`;
        case QA_HOST:
            return `${QA_ASSETS_URL}${url}`;
        case OCULTO_HOST:
            return `${OCULTO_ASSETS_URL}${url}`;
        case PROD_HOST:
            return `${PROD_ASSETS_URL}${url}`;
        default:
            return `${STAGING_ASSETS_URL}${url}`;
      }
}

const buildFooterNgoList = (ngoId, onClickFunction, FormattedText) => {
    return (
        <OkNgoBoxFooter
            onClickFunction={(e) => onClickFunction(ngoId, e)}
            FormattedText={FormattedText}
        />
    )
}

const formatNgosListArray = (ngosList, categoryId, onClickFunction, environmentConfig, selected, FormattedText) => {
    let contentCategory = [];
    ngosList.map((ngo) => {
        ngo.categories.map((category) => {
            if(category.ngoCategoryId === categoryId) {
                contentCategory.push(
                    {
                        titleOption: ngo.name,
                        ngoId: ngo.ngoId,
                        deductible: ngo.deductible,
                        image: getUrlImages(ngo.imagelogo, environmentConfig),
                        footerContentOption: buildFooterNgoList(ngo.uniquename, onClickFunction, FormattedText),
                        category: categoryId,
                        iban: ngo.iban,
                        cif: ngo.cif,
                        country: ngo.country,
                        imageLogo: ngo.imagelogo,
                        categories: ngo.categories,
                        uniquename: ngo.uniquename,
                        selected: selected.includes(ngo.ngoId)
                    }
                )
            }
        })
    })

    return contentCategory;
}


const getCategoriesNgos = (ngosList, onClickFunction, environmentConfig, selected, FormattedText) => {
    let arrayCategoriesId = [];
    let listCategories = []

    for (let i = 0; i < ngosList.length; i += 1) {
        for (let j = 0; j < ngosList[i].categories.length; j += 1) {
            if(!arrayCategoriesId.includes(ngosList[i].categories[j].ngoCategoryId)) {
                arrayCategoriesId.push(ngosList[i].categories[j].ngoCategoryId);
                const categoryId = ngosList[i].categories[j].ngoCategoryId;
                const color = ngosList[i].categories[j].color;

                listCategories.push(
                    {
                        image: getUrlImages(ngosList[i].categories[j].image, environmentConfig),
                        id: categoryId,
                        name: `name-${ngosList[i].categories[j].ngoCategoryId}`,
                        content: formatNgosListArray(ngosList, categoryId, onClickFunction, environmentConfig, selected,FormattedText),
                        color: color
                    }
                )
            }
        }
    }

    return listCategories;
}


module.exports = {
    getCategoriesNgos,
    getUrlImages
}
